import PageMetaData from './PageMetaData'

export default PageMetaData
